/**
 * jobManagementUtils.js
 * Centralized utility helpers for Backoffice Job Management
 */

/**
 * Generates standardized authorization headers for management APIs
 * @param {string} token
 * @returns {object}
 */
export const getAuthHeaders = (token) => ({
  Accept: 'application/json',
  Authorization: 'Bearer ' + (token || ''),
});

/**
 * Formats salary display text
 * @param {number|null} salary
 * @returns {string}
 */
export const formatSalary = (salary) => {
  if (salary && salary > 0) {
    return `${salary.toLocaleString()} บาท`;
  }
  return 'ตามตกลง';
};
